export enum UserGenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  DIVERS = 'DIVERS',
}

export enum UserRoleEnum {
  USER = 'USER',
  COACH = 'COACH',
}
